interface GraphWithMagnificationSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphWithMagnificationSVG = ({
  color,
  style,
}: GraphWithMagnificationSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="49"
    viewBox="0 0 58 49"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19558)">
      <path
        d="M36.5485 18.1736C38.0322 18.1736 39.2349 16.9708 39.2349 15.4872C39.2349 14.0035 38.0322 12.8008 36.5485 12.8008C35.0649 12.8008 33.8621 14.0035 33.8621 15.4872C33.8621 16.9708 35.0649 18.1736 36.5485 18.1736Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2911 38.0535C24.7748 38.0535 25.9775 36.8507 25.9775 35.3671C25.9775 33.8834 24.7748 32.6807 23.2911 32.6807C21.8074 32.6807 20.6047 33.8834 20.6047 35.3671C20.6047 36.8507 21.8074 38.0535 23.2911 38.0535Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2889 38.0535C11.7726 38.0535 12.9753 36.8507 12.9753 35.3671C12.9753 33.8834 11.7726 32.6807 10.2889 32.6807C8.80528 32.6807 7.60254 33.8834 7.60254 35.3671C7.60254 36.8507 8.80528 38.0535 10.2889 38.0535Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.358 48.3289C4.84166 48.3289 6.04441 47.1261 6.04441 45.6425C6.04441 44.1588 4.84166 42.9561 3.358 42.9561C1.87434 42.9561 0.6716 44.1588 0.6716 45.6425C0.6716 47.1261 1.87434 48.3289 3.358 48.3289Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.3341 29.0273L24.5806 33.0032"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8829 18.1738L30.4638 24.5137"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.70398 37.8252L5.26538 42.7547"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.148 35.2852L13.5126 35.4329"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8305 29.7287C46.8042 28.7468 52.4723 21.4868 51.4904 13.513C50.5085 5.53918 43.2485 -0.128882 35.2747 0.853001C27.3009 1.83489 21.6329 9.09489 22.6148 17.0687C23.5967 25.0425 30.8567 30.7105 38.8305 29.7287Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.4493 30.9609L55.8369 42.8886C57.0592 44.8631 57.3144 46.9182 56.4145 47.4689C55.5145 48.033 53.7818 46.8779 52.5595 44.9168L45.1719 32.9892"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.9737 34.3989C44.8898 33.8347 49.3224 31.0812 52.0222 26.9307"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19558">
        <rect width="57.7039" height="49" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphWithMagnificationSVG;
